import React, {useRef, useState} from 'react';
import Grid from "@mui/material/Grid";
import "./Reporting.css";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import {useDispatch, useSelector} from "react-redux";
import {ContainerHeader} from "../../module";
import TextField from "@mui/material/TextField";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import Autocomplete from "@mui/material/Autocomplete";

import {useHistory} from "react-router";
import ReactToPrint from "react-to-print";
import axios from "axios";
import {strings} from "../../../strings";
import {selToken} from "../../../stores/base/baseSlice";
import {notification} from "../../functions/notification/notificationFunction";
import failStatus from "../../utils/failStatus";

export default function Reporting() {

    const history = useHistory();
    const mToken = useSelector(selToken);
    const dispatch = useDispatch();
    let componentRef = useRef();

    const [type, setType] = useState("order");
    const [start_date, setStart_date] = useState(null);
    const [end_date, setEnd_date] = useState(null);
    const [resultOrder, setResultOrder] = useState([]);
    const [resultUser, setResultUser] = useState([]);

    const provinces = [
        {
            name: "فروش",
            value: "order"
        },
        {
            name: "کاربر",
            value: "user"
        }
    ];

    function setTime(e, name) {
        // const value = moment(e).format(`YYYY-MM-DD`)
        const value = moment(e).format(`jYYYY/jMM/jDD HH:mm:ss`)
        if (name === "start_date") {
            setStart_date(value)
        } else setEnd_date(value)
    }


    async function getReportOrder() {
        if(start_date === null || end_date === null){
            return  dispatch(notification("error","خوش آمدید",<h3>تاریخ ها را وارد کنید</h3>,false))
        }
        await axios({
            method: 'post',
            url: strings.baseUrl + `admin/report/user/order`,
            data: {
                start_date: start_date,
                end_date: end_date,
            },
            headers: {
                "Authorization": `Bearer ${mToken}`
            }
        })
            .then(result => {
                failStatus(result.data)
                if (result.data.status_code === 200) {
                    setResultOrder(result.data.data);
                    // document.getElementById('print-button').click();
                } else alert("خطایی رخ داد");
            })
            .catch(error => {
                console.log(error)
            })
    }

    async function getReportUser() {
        if(start_date === null || end_date === null){
            return  dispatch(notification("error","خوش آمدید",<h3>تاریخ ها را وارد کنید</h3>,false))
        }
        await axios({
            method: 'post',
            url: strings.baseUrl + `admin/report/sale`,
            data: {
                start_date: start_date,
                end_date: end_date,
            },
            headers: {
                "Authorization": `Bearer ${mToken}`
            }
        })
            .then(result => {
                failStatus(result.data)
                if (result.data.status_code === 200) {
                    setResultUser(result.data.data);
                    // document.getElementById('print-button').click();
                } else alert("خطایی رخ داد");
            })
            .catch(error => {
                console.log(error)
            })
    }


    function ComponentToPrint({myKey}) {
        return (
            <div ref={myKey} className="tablePrint">
                {(resultUser.length !== 0 || resultOrder.length !== 0) &&
                <div className="d-flex justify-content-end">
                    <Button
                        variant="contained"
                        onClick={()=>document.getElementById('print-button').click()}
                        className="continuationButtonCreateProduct mr-3 mt-5"
                    >
                        پرینت
                    </Button>
                </div>
                }

                {type === "order" ?
                    <table>

                        <thead>
                        {resultOrder.length !== 0 &&
                        <tr>
                            <th>نام</th>
                            <th>تعداد فروش کل</th>
                            <th>تاریخ آخرین فروش</th>
                        </tr>
                        }
                        </thead>
                        <tbody>
                        {resultOrder.map((data,i)=>(
                            <tr key={i}>
                                <td>{data.name}</td>
                                <td>{data.total_sold}</td>
                                <td>{data.created_at}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                :
                    <table>
                        <thead>
                        {resultUser.length !== 0 &&
                        <tr>
                            <th>نام</th>
                            <th>نام خانوادگی</th>
                            <th>کد پیگیری</th>
                            <th>جمع خرید</th>
                        </tr>
                        }
                        </thead>
                        <tbody>
                        {resultUser.map((data,i)=>(
                            <tr key={i}>
                                <td>{data.first_name}</td>
                                <td>{data.last_name}</td>
                                <td>{data.tracking_code}</td>
                                <td>{data.delivery_amount + data.product_amount}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                }

            </div>
        );
    }


    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="گزارش گیری"
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />
            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        className={`w-100`}
                                        value={type && provinces.find(data => data.value === type)}
                                        options={provinces}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, value) => {
                                            setType(value?.value)
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       variant="outlined"
                                                       className={`w-100`}
                                                       label="نوع گزارش"/>
                                        )}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        className={`DatePickerUserPanel`}
                                        // timePicker={false}
                                        value={start_date !== null ? moment(start_date, 'jYYYY/jMM/jDD HH:mm:ss') : null}
                                        onChange={(e) => setTime(e, 'start_date')}
                                        placeholder={`از تاریخ`}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        // className={`DatePickerUserPanel ${end_date && "redBorder"}`}
                                        className={`DatePickerUserPanel`}
                                        // timePicker={false}
                                        value={end_date !== null ? moment(end_date, 'jYYYY/jMM/jDD HH:mm:ss') : null}
                                        onChange={(e) => setTime(e, 'end_date')}
                                        placeholder={`تا تاریخ`}
                                    />
                                </Grid>
                            </Grid>
                            <ReactToPrint
                                trigger={() => <Button id="print-button" style={{visibility: "hidden"}}>Print this out!</Button>}
                                content={() => componentRef}
                            />

                            <div>
                                <ComponentToPrint myKey={(el) => (componentRef = el)} />
                            </div>
                        </div>
                        <Button
                            variant="contained"
                            onClick={type === "order" ? getReportOrder : getReportUser}
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            نمایش
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}

